var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoPilotLogoDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2410,
    height: 340,
    viewBox: "0 0 2410 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9215_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.823 331.926C393.124 331.926 389.218 331.99 385.034 331.999C373.573 331.926 371.835 328.627 371.31 320.042C371.93 293.217 371.29 266.373 371.669 239.543C371.785 231.191 369.587 224.161 364.714 216.805C335.217 172.294 306.498 127.388 277.197 82.7759C272.373 75.4324 271.958 71.6005 283.394 72.4127C283.969 72.4535 284.552 72.4296 285.129 72.4134C336.271 70.9729 335.96 71.1218 360.838 110.992C380.177 141.981 400.303 172.596 420.327 203.254C426.465 212.653 430.008 222.091 429.658 233.299C428.826 260.113 428.402 287 429.785 313.781C430.531 328.218 425.724 331.926 409.136 331.99C406.335 331.546 403.364 331.926 398.823 331.926Z",
    fill: "#645EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.79 128.132C487.073 146.861 473.848 164.623 459.847 183.428C447.588 172.042 440.326 158.713 430.944 146.579C428.055 142.843 431.052 139.217 433.384 135.919C446.694 117.112 460.145 98.3713 473.344 79.5132C476.852 74.5037 481.259 71.8769 488.672 72.0044C506.072 72.3038 523.483 72.1002 544.052 72.1002C528.846 91.6774 515.065 109.421 500.79 128.132Z",
    fill: "#D21D71"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9215_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1845.23 73.488C1777.73 82.174 1733.45 132.118 1733.02 200.738C1732.59 269.792 1778.59 321.907 1848.67 331.028C1877.47 334.937 1920.46 326.686 1946.26 312.788L1966.46 301.496V249.814V198.567H1942.82H1919.17V237.654C1919.17 276.306 1919.17 277.175 1907.56 281.952C1900.69 284.558 1883.92 287.164 1869.3 287.164C1847.38 287.598 1840.07 285.427 1822.44 274.569C1792.35 255.894 1780.31 231.139 1782.89 195.092C1784.61 172.943 1787.62 164.257 1797.51 151.662C1821.15 122.564 1829.75 118.221 1869.3 118.221C1901.55 118.221 1906.7 119.524 1923.04 130.816L1941.1 143.41L1955.71 129.078L1970.76 114.312L1960.87 103.889C1939.81 80.4368 1890.8 67.4078 1845.23 73.488Z",
    fill: "#645EFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9215_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 202V331.999H30.2886H56.577V276.915V221.83H125.883H195.189V276.915V331.999H223.868H252.546L251.591 202.881L250.156 74.2034H223.868H197.579L196.145 125.763L194.711 177.763H125.883H56.577V124.881V72H30.2886H4V202Z",
    fill: "#645EFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_9215_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.773 202.219V331.999H602.614H628.452V294.731V257.463H671.206C723.826 257.463 749.195 251.764 771.277 234.664C795.239 216.249 803.225 199.15 803.696 167.581C804.165 128.56 789.6 105.76 753.425 89.0995C727.585 76.8229 722.417 75.946 651.473 74.1922L576.773 72V202.219ZM719.597 123.298C748.726 134.698 759.061 163.636 744.028 191.258C734.161 208.796 717.718 213.619 670.737 213.619H628.452V165.389V117.16H666.038C687.649 117.16 710.671 119.791 719.597 123.298Z",
    fill: "#645EFF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_9215_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M857.699 202.219V331.999H883.799H909.898V294.731V257.463H944.539H979.653L1007.18 294.731L1035.17 331.999H1065.54H1095.44L1063.64 289.47C1043.72 263.163 1033.75 246.502 1037.55 245.187C1048.46 241.679 1071.71 221.072 1079.3 207.919C1083.58 200.027 1086.9 182.927 1086.9 167.581C1087.37 128.56 1072.66 105.76 1036.12 89.0995C1010.02 76.8229 1004.8 75.946 933.149 74.1922L857.699 72V202.219ZM1001.96 123.298C1031.38 134.698 1041.82 163.636 1026.63 191.258C1017.14 207.919 999.584 214.057 951.656 216.688L909.898 219.318V168.02V117.16H947.861C969.688 117.16 992.941 119.791 1001.96 123.298Z",
    fill: "#645EFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_9215_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1419.55 202V331.999H1489.31C1567.27 331.999 1595.54 326.712 1627 305.559C1664.39 280.44 1681.72 242.983 1678.53 193.627C1675.34 146.474 1655.27 115.186 1614.24 92.2711C1586.43 76.8475 1554.96 72 1483.38 72H1419.55V202ZM1564.08 121.356C1611.05 132.373 1637.49 180.847 1622.44 228.44C1609.22 271.627 1579.13 287.932 1513.02 287.932H1469.7V202V116.068H1506.63C1526.7 116.068 1552.68 118.271 1564.08 121.356Z",
    fill: "#645EFF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_9215_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2046.49 202V331.999H2143.97H2241L2239.68 310.847L2238.36 290.135L2166.91 288.813L2095.01 287.932V254.881V221.83H2157.21H2218.95L2217.64 200.678L2216.32 179.966L2155.88 178.644L2095.01 177.322V146.915V116.068H2166.03H2236.59L2235.27 94.9152L2233.95 74.2034L2140.44 72.8814L2046.49 72V202Z",
    fill: "#645EFF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_9215_14042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1327.24 288.666C1354.49 288.667 1354.49 288.667 1354.49 311.397C1354.49 314.569 1354.13 317.779 1354.56 320.906C1355.65 328.957 1352.45 332.056 1342.74 331.999C1285.33 331.659 1227.91 331.689 1170.5 331.98C1162.12 332.023 1159.4 329.361 1160.47 322.535C1160.54 322.091 1160.48 321.63 1160.47 321.176C1159.65 288.666 1159.65 288.666 1196.53 288.666C1239.59 288.666 1282.65 288.666 1327.24 288.666Z",
    fill: "#645EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.13 180.333C1311.32 180.335 1311.32 180.335 1311.32 203.065C1311.32 206.238 1311.05 209.448 1311.38 212.575C1312.23 220.624 1309.74 223.723 1302.18 223.665C1257.53 223.327 1212.87 223.358 1168.22 223.648C1161.7 223.69 1159.59 221.028 1160.42 214.202C1160.47 213.758 1160.43 213.297 1160.42 212.844C1159.78 180.333 1159.78 180.333 1188.47 180.333C1221.96 180.333 1255.45 180.333 1290.13 180.333Z",
    fill: "#D21D71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1327.24 72C1354.49 72.0017 1354.49 72.0017 1354.49 94.7325C1354.49 97.9047 1354.13 101.114 1354.56 104.242C1355.65 112.291 1352.45 115.39 1342.74 115.332C1285.33 114.994 1227.91 115.025 1170.5 115.314C1162.12 115.357 1159.4 112.695 1160.47 105.869C1160.54 105.424 1160.48 104.963 1160.47 104.511C1159.65 72.0003 1159.65 72.0003 1196.53 72.0003C1239.59 72.0003 1282.65 72.0002 1327.24 72Z",
    fill: "#645EFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2338 144C2377.76 144 2410 111.765 2410 72C2410 32.2355 2377.76 0 2338 0C2298.24 0 2266 32.2355 2266 72C2266 111.765 2298.24 144 2338 144Z",
    fill: "url(#paint0_linear_9215_14042)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2331.14 107.426L2323.92 85.3445H2304.33L2296.71 107.426H2304.13V109.368H2289V107.426H2293.65L2318.87 37.1948H2326.98L2351.91 107.426H2356.46V109.368H2324.11V107.426H2331.14ZM2314.52 56.3116L2305.22 83.0954H2323.12L2314.52 56.3116Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2371.16 53.0145C2367.67 53.0145 2365.16 52.0945 2363.65 50.2543C2362.2 48.4142 2361.47 46.1311 2361.47 43.405C2361.47 40.6789 2362.26 38.4299 2363.84 36.6579C2365.49 34.886 2367.97 34 2371.26 34C2374.56 34 2377.07 34.8178 2378.78 36.4535C2380.49 38.021 2381.35 40.3041 2381.35 43.3028C2381.35 46.2333 2380.53 48.5846 2378.88 50.3566C2377.23 52.1285 2374.66 53.0145 2371.16 53.0145ZM2356.23 60.0683H2380.46V106.889H2386V108.729H2356.62V106.889H2362.06V61.9084H2356.23V60.0683Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9215_14042",
    x: 270,
    y: 72,
    width: 278.053,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9215_14042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9215_14042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9215_14042",
    x: 1729.02,
    y: 72,
    width: 245.74,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9215_14042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9215_14042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9215_14042",
    x: 0,
    y: 72,
    width: 256.547,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9215_14042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9215_14042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_9215_14042",
    x: 572.773,
    y: 72,
    width: 234.934,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9215_14042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9215_14042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_9215_14042",
    x: 853.699,
    y: 72,
    width: 245.74,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9215_14042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9215_14042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_9215_14042",
    x: 1415.55,
    y: 72,
    width: 267.354,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9215_14042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9215_14042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_9215_14042",
    x: 2042.49,
    y: 72,
    width: 202.506,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9215_14042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9215_14042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_9215_14042",
    x: 1156.25,
    y: 72,
    width: 202.516,
    height: 268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9215_14042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9215_14042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9215_14042",
    x1: 2304.33,
    y1: 27.7222,
    x2: 2383.67,
    y2: 144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F14684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E72BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoPilotLogoDarkMode);
export default __webpack_public_path__ + "static/media/CoPilotLogoDarkMode.c8416b1564e69d0c2e45a964518756cb.svg";
export { ForwardRef as ReactComponent };